// @flow
import Record from "../flow/Record";
import { List } from "immutable";
import {
    jsToUserSettingsRecord,
    Languages,
    UserSettings
} from "./userSettings.record";

export class Post extends Record({
    id: "",
    author: new UserSettings({}),
    creationDate: new Date(),
    lastUpdateDate: new Date(),
    body: "",
    language: Languages.en,
    corrections: List(),
    reactions: List(),
    reportedUsers: new List()
}) {
    id: string;
    author: UserSettings;
    creationDate: Date;
    lastUpdateDate: Date;
    body: string;
    language: string;
    corrections: List<Correction>;
    reactions: List<Reaction>;
    reportedUsers: List<string>;
}

export class Reaction extends Record({
    id: "",
    userId: "",
    creationDate: new Date()
}) {
    id: string;
    userId: string;
    creationDate: Date;
}

export class Correction extends Record({
    id: "",
    postId: "",
    body: "",
    author: new UserSettings({}),
    creationDate: new Date(),
    lastUpdateDate: new Date(),
    edits: List(),
    reactions: List(),
    comment: "",
    reportedUsers: List()
}) {
    id: string;
    postId: string;
    body: string;
    author: UserSettings;
    creationDate: Date;
    lastUpdateDate: Date;
    edits: List<Edit>;
    comment: String;
    reactions: List<Reaction>;
    reportedUsers: List<string>;
}

export class Edit extends Record({
    id: "",
    startIndex: 0,
    length: 0,
    type: "",
    newText: "",
    comment: ""
}) {
    id: string;
    startIndex: number;
    length: number;
    newText: string;
    comment: string;
}

export function jsToEditRecord(edit: any): Edit {
    return new Edit(edit);
}

export function jsToCorrectionRecord(correction: any): Correction {
    return new Correction({
        ...correction,
        author: jsToUserSettingsRecord(correction.author),
        edits: List((correction.edits || []).map(jsToEditRecord)),
        creationDate: new Date(correction.creationDate),
        lastUpdateDate: new Date(correction.lastUpdateDate),
        reactions: List((correction.reactions || []).map(jsToReactionRecord)),
        reportedUsers: List(correction.reportedUsers || [])
    });
}

export function jsToPostRecord(post: any): Post {
    return new Post({
        ...post,
        creationDate: new Date(post.creationDate),
        lastUpdateDate: new Date(post.lastUpdateDate),
        author: jsToUserSettingsRecord(post.author),
        corrections: List((post.corrections || []).map(jsToCorrectionRecord)),
        reactions: List((post.reactions || []).map(jsToReactionRecord)),
        reportedUsers: List(post.reportedUsers || [])
    });
}

export function jsToReactionRecord(reaction: any): Reaction {
    return new Reaction({
        ...reaction,
        creationDate: new Date(reaction.creationDate)
    });
}



// WEBPACK FOOTER //
// ./src/records/post.record.js